<div class="modal-header">
   <h2 class="text-dark fw-bold fs-5 text-center">
    {{ pollData ? 'EDIT POLL' : 'CREATE POLL' }}
  </h2>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>


<div class="modal-body px-10 pt-3 pb-4">
  <div class="my-3 w-100">
    <form [formGroup]="pollForm" (ngSubmit)="onSubmit()">
      <!-- Question -->
      <div class="mb-3">
        <label class="form-label fw-bold">Your Question <span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="question" placeholder="Enter your question" />
      </div>

        <!-- Options -->
      <div class="mb-3">
        <label class="form-label fw-bold">Options <span class="text-danger">*</span></label>
        <div formArrayName="options">
          <div *ngFor="let option of optionControls.controls; let i = index" [formGroupName]="i"
            class="form-group mt-3 position-relative" >
            <input type="text" class="form-control" formControlName="value" placeholder="Option {{ i + 1 }}" />
            <button *ngIf="i >= 2" type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0 mt-1 me-1" (click)="removeOption(i)">
                ×
        </button>
          </div>

        </div>
        <button type="button" class="btn btn-primary btn-sm mt-2" (click)="addOption()"
          [disabled]="optionControls.length >= 10">
          + Add Option
        </button>
      </div>

        <!-- Duration Time -->
      <div class="mb-3">
        <label class="form-label fw-bold">Poll Duration <span class="text-danger">*</span></label>
        <select class="form-select" formControlName="timeLine">
          <option *ngFor="let duration of pollDurations" [value]="duration.value">
            {{ duration.label }}
          </option>
        </select>
      </div>

       <div class="my-2 d-flex justify-content-end">
      <button type="submit" class="btn btn-primary ls-2 text-uppercase fw-boldest btn-active-light-primary" [disabled]="pollForm.invalid">  
       Save
      </button>
    </div>
    </form>

  </div>
</div>